/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'


interface IPasture {
  idPasto: string;
  descricao: string;
}

export interface PastureState {
  isLoading: boolean,
  list: Array<IPasture>
}

const customModule = '@PASTURE'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: PastureState = {
  isLoading: false,
  list: [],
}

export const pastureReducer: Reducer<PastureState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.SUCCESS:
    case GET.REQUEST:
      return { ...state, isLoading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    default:
      return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getPastureList = (farmId: string) => ({ type: GET.REQUEST, payload: farmId })


const ROUTE = '/entity/Pasto'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${payload}`)
    yield put({ type: GET.SUCCESS, payload: data })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar lista de pasto. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

export const pastureSaga = all([
  takeLatest(GET.REQUEST, get),
])
